module.exports = __webpack_public_path__ + "static/media/cm.b4c9e39c.svg";